import { render, staticRenderFns } from "./article-page.vue?vue&type=template&id=8e3cab5e&scoped=true&"
import script from "./article-page.vue?vue&type=script&lang=js&"
export * from "./article-page.vue?vue&type=script&lang=js&"
import style0 from "./article-page.vue?vue&type=style&index=0&id=8e3cab5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3cab5e",
  null
  
)

export default component.exports